import React, { useState, useEffect, useRef } from "react";
import { TableContainer, Paper, Typography, Box, Grid } from "@mui/material";
import { api, get, post } from "../../../../utils/api";
import PaginationBox from "../../../../Components/Masters/Pagination";
import DeleteDialog from "../../../../Components/Masters/DeleteDialog";
import ColumnHeadings from "../../../../Components/Masters/ColumnHeadings";
import MenuActions from "../../../../Components/Masters/MenuActions";
import TableContent from "../../../../Components/Masters/TableContent";
import FilterDrawer from "../../../../Components/Masters/FilterDrawer";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import TableHeading from "../../../../Components/Masters/TableHeading";
import MenuIcon from "../../../../Components/Masters/MenuIcon";
import { companyId } from "../../../../utils/companyId";
import Add from "./Add";
import View from "./View";
import DateRangePickerComponent from "../../../Masters/Roles and Permissions/Filters/Date";
import MultiSelect from "../../../Masters/Roles and Permissions/Filters/MultiSelect";
import Range from "../../../Masters/Roles and Permissions/Filters/Range";
import Cards from "../../../../Components/Common/Cards";
import NoDataFound from "../../../../Components/Masters/NoDataFound";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import Scope1Layout from "../../../../Layout/Scope1Layout";
import { getMonthName } from "../../../../utils/getMonthName";
import MonthYearFilter from "../../../Masters/Roles and Permissions/Filters/MonthYearFilter";
import BulkUploadModal from "../../../../Components/Common/BulkUploadModal";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import TopMenuUpload from "../../../../Components/Masters/TopMenuUpload";
import {
  formatNumberCommaSeparated,
  truncateNumber,
} from "../../../../utils/common";
import Scope4Layout from "../../../../Layout/Scope4Layout";
import FugitiveBulkUpload from "../../../Scope1/FugitiveEmmissions/FugitiveBulkUpload";
import DeleteAlertDialog from "../../../../Components/Masters/DeleteAlertDialog";
import { useUser } from "../../../../context/AuthContext";
import {FacilityColumnHeading,
  facilityDataCellSx,
  getFacilityName,
  getGridTableRowSx,
  GRID_TABLE_ACTION_COL,
  gridTableActionHeaderSx,
  gridTablePaperSx,
  isFacilityHeading,
  shouldShowFacilityColumn,
  withFacilityHeading, FacilityDataCell, MasterDateDataCell } from "../../../../utils/facilityColumn";
// import BulkUpload from "../NaturalGas/BulkUpload";

const RenewableEnergyExport = () => {
  const { user } = useUser();
  const showFacilityColumn = shouldShowFacilityColumn(user);
  const columnWidth = showFacilityColumn
    ? `minmax(0, 0.9fr) minmax(0, 1.1fr) minmax(0, 1fr) minmax(0, 1.2fr) minmax(0, 1.1fr) minmax(0, 1.1fr) ${GRID_TABLE_ACTION_COL}`
    : `minmax(0, 1fr) minmax(0, 1.2fr) minmax(0, 1.4fr) minmax(0, 1.2fr) minmax(0, 1.2fr) ${GRID_TABLE_ACTION_COL}`;
  const [selectedDate, setSelectedDate] = useState({});
  const [cardData, setCardData] = useState(null);
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const tableContainerRef = useRef(null); // Reference to the table container
  const [isShortContent, setIsShortContent] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [addData, setAddData] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    "Month of energy export": false,
    Importer: false,
    "Type of renewable energy": false,
  });
  const [viewData, setViewData] = useState(false);
  const [element, setElement] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [limit] = useState(10); // Number of items per page
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [selectedMonth, setSelectedMonth] = useState(""); // Stores the selected month
  const [selectedYear, setSelectedYear] = useState(""); // Stores the selected year
  const [uniqueValues, setUniqueValues] = useState({});
  const [errors, setErrors] = useState({
    "Quantity Consumed": false,
    "Hours Used": false,
  });
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [selectedFields, setSelectedFields] = useState({
    importer: [],
    typeOfRenewableEnergy: [],
  });

  const [startMonth, setStartMonth] = useState(null);
  const [endMonth, setEndMonth] = useState(null);

  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [excelData, setExcelData] = useState(null);

  const [bulkUploadTable, setBulkUploadTable] = useState(true);

  const [formDataBulkUpload, setFormDataBulkUpload] = useState({});
  const [matchData, setMatchData] = useState([]);

  const [tempFilter, setTempFilter] = useState({
    startDate: null,
    endDate: null,
    startMonth: null,
    endMonth: null,
    importer: [],
    typeOfRenewableEnergy: [],
  });

  let bannerData = [
    {
      title: "Total Energy Exported",
      description: truncateNumber(cardData?.total),
      // unit: cardData?.total?.unit,
    },
    {
      title: "Top Renewable Energy Type Exported Annually",
      description:
        cardData?.topProjectTypes?.length > 0
          ? cardData?.topProjectTypes.map((el) => el.typeOfRenewableEnergy)
          : "N/A",
    },
    {
      title: "Energy Export Month",
      description: truncateNumber(cardData?.monthly?.totalenergyExported),
      // unit: cardData?.monthly?.unit || "",
      filter: "date",
      defaultValue: {},
    },
  ];

  const allowedVerificationStatus = ["Solar", "wind", "biogas power"];
  const onConfirm = async () => {
    try {
      // const excelData = Object.values(formDataBulkUpload);
      // console.log(excelData, "excelData to send");
      // const response = await post(
      //   `/scope4/renewable-energy-export-avoidance/jsonupload`,
      //   { excelData }
      // );
      setBulkUploadTable(false);
      fetchData();
      
    } catch (error) {
      console.log(error, "error");
    }
  };
  const fetchExcelData = async () => {
    await get("/scope4/renewable-energy-export-avoidance/exportExcel")
      .then((res) => {
        let data = res?.data?.data;
        console.log(data, "data1");
        let arr = [];
        data &&
          // data.forEach((el, idx) => {
          allowedVerificationStatus.forEach((status) => {
            arr.push({
              Importer: "",
              "Month (in 01/25 or Jan-25)": "",
              "Type of renewable energy": status,
              "Energy exported (kWh)": "",
              "Grid emission factor (kg CO2e/kWh)": "",
              "Remark (optional)": "",
            });
            // });
          });
        setExcelData(arr);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchExcelData();
  }, []);

  const fetchCardData = async (month, year) => {
    try {
      console.log(month, year, selectedMonth, selectedYear);
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth(); // Current month (0-based, January = 0)
      const response = await get(
        `/scope4/renewable-energy-export-avoidance/cardData?year=${
          selectedYear ? selectedYear : currentYear
        }&month=${selectedMonth ? selectedMonth : currentMonth + 1}`
      );
      console.log(response.data, "data");
      setCardData(response.data);
    } catch (error) {
      console.error("Error fetching card data:", error);
    }
  };

  useEffect(() => {
    fetchCardData();
  }, [selectedMonth, selectedYear]);

  const handlePeriodChange = (key, value, filterType) => {
    const [year, month] = value.split("-");
    setSelectedDate((prev) => ({
      ...prev,
      month,
      year,
    }));
    fetchCardData(year, month, "");
  };

  const filters = [
    "Date",
    "Month of energy export",
    "Importer",
    "Type of renewable energy",
  ];

  const inputData = [
    {
      fieldName: "consumptionPeriod",
      title: "Month of energy export",
      required: true,
      type: "date",
    },
    {
      fieldName: "importer",
      title: "Importer",
      placeholder: "Enter Importer",
      type: "text",
      required: true,
    },
    {
      fieldName: "typeOfRenewableEnergy",
      title: "Type of renewable energy",
      placeholder: "Type here",
      type: "select",
      options: ["Solar", "Wind", "Biogas"],
      required: true,
    },

    {
      fieldName: "energyExported",
      title: "Energy exported (kWh)",
      placeholder: "Enter Energy exported",
      type: "number",
      required: true,
      // adornmentText: "MT",
      // options: ["MT", "Kg"],
    },
    {
      fieldName: "emissionFactor",
      title: "Grid emission factor (kg CO2e/kWh)",
      placeholder: "Enter Grid emission factor",
      type: "number",
      required: true,
    },

    {
      fieldName: "remarks",
      title: "Remark (optional)",
      placeholder: "Additional remarks",
      type: "text",
    },
    {
      fieldName: "editRemarkReason",
      title: "Edit Remark Reason",
      placeholder: "Additional edit remarks",
      type: "text",
      condition: true,
    },
    {
      fieldName: "documents",
      title: "Upload Documents (optional)",
      type: "file",
    },
  ];

  const fetchUniqueValues = async () => {
    try {
      const response = await get(
        `/scope4/renewable-energy-export-avoidance/get?limit=null`
      );
      const data = response.data.data;

      const uniqueImporter = [
        ...new Set(data.map((el) => el.importer).filter(Boolean)),
      ];

      const uniqueTypeOfRenewableEnergy = [
        ...new Set(data.map((el) => el.typeOfRenewableEnergy).filter(Boolean)),
      ];

      return {
        importer: uniqueImporter,
        typeOfRenewableEnergy: uniqueTypeOfRenewableEnergy,
      };
    } catch (error) {
      console.error("Error fetching unique values:", error);
      return {};
    }
  };

  // useEffect(()=>{
  //   fetchCardData();
  // })

  // fetching Vehicle data
  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {},
    pageNumber
  ) => {
    fetchCardData(selectedMonth, selectedMonth);
    console.log(pageNumber, "pageNumber");
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page: pageNumber ? pageNumber : page, // Add the current page
        limit: rowsPerPage, // Add the number of rows per page
        sortField: sortConfig.key, // Sort configuration
        sortOrder: sortConfig.direction,
        company: companyId,
        createdBy: companyId,
      }).toString();
      const response = await get(
        `/scope4/renewable-energy-export-avoidance/get?${queryParams}`
      );
      setData(response.data.data); // Update the user list
      setTotalPages(response.data.totalPages); // Update total pages for pagination
      const uniqueValues = await fetchUniqueValues();
      setUniqueValues(uniqueValues);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const updatePage = () => {
    if (page > 1 && data.length === 1) {
      setPage(page - 1);
    }
    fetchData();
  };

  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage, sortConfig]);

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      const tableHeight = container.scrollHeight; // Get the table's height
      const screenHeight = window.innerHeight; // Get the viewport height

      // If table content is less than half the screen height, set pagination to be at the bottom
      setIsShortContent(tableHeight < screenHeight / 3);
    }
  }, [data]);

  const handleMenuClick = (event, element) => {
    setAnchorEl(event.currentTarget);
    setSelectedData(element);
    setElement(element);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedData(null);
  };

  const handleEdit = () => {
    handleMenuClose();
    setAddData(true);
    setViewData(false);
  };

  const handleView = () => {
    handleMenuClose();
    setViewData(true);
    setAddData(false);
  };

  const handleDelete = () => {
    handleMenuClose();
    setDeleteDialog(true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const filtersToApply = {
    startDate: tempFilter?.startDate
      ? tempFilter?.startDate.format("YYYY-MM-DD")
      : "",
    endDate: tempFilter?.endDate
      ? tempFilter?.endDate.format("YYYY-MM-DD")
      : "",
    startMonth: tempFilter?.startMonth
      ? tempFilter?.startMonth.format("YYYY-MM")
      : "",
    endMonth: tempFilter?.endMonth
      ? tempFilter?.endMonth.format("YYYY-MM")
      : "",
    importer: tempFilter?.importer || "",
    typeOfRenewableEnergy: tempFilter?.typeOfRenewableEnergy || "",
  };

  // function to validate filters
  const validateFilters = () => {
    let isValid = true;
    const newErrors = {
      Date: false,
      Importer: false,
      "Type of renewable energy": false,
    };
    setErrors(newErrors);
    return isValid;
  };

  // Applying selected filters
  const handleApplyFilters = () => {
    if (!validateFilters()) return;
    setPage(1);
    setStartDate(tempFilter?.startDate);
    setEndDate(tempFilter?.endDate);
    setSelectedFields({
      importer: tempFilter?.importer || [],
      typeOfRenewableEnergy: tempFilter?.typeOfRenewableEnergy || [],
    });
    setStartMonth(tempFilter?.startMonth);
    setEndMonth(tempFilter?.endMonth);
    fetchData(filtersToApply, 1);
    handleAppliedFilters();
    setDrawerFilterOpen(false);
  };

  const handleResetFilters = async () => {
    // Reset local state for date selection and selected fields
    // setPage(1);
    setTempFilter({
      startDate: null,
      endDate: null,
      startMonth: null,
      endMonth: null,
      importer: [],
      typeOfRenewableEnergy: [],
    });
    setStartDate(null);
    setEndDate(null);
    setStartMonth(null);
    setEndMonth(null);
    setSelectedFields({
      importer: [],
      typeOfRenewableEnergy: [],
    });

    // Call fetchData without any filters
    await fetchData({ pageNumber: 1 });
    setErrors({});
    setAppliedFilters({});
    setIsFiltersApplied(false);
    setDrawerFilterOpen(false);
  };

  const handleAppliedFilters = () => {
    const isDateApplied = tempFilter?.startDate || tempFilter?.endDate;
    const isMonthApplied = tempFilter?.startMonth || tempFilter?.endMonth;

    const isImporterApplied = tempFilter?.importer?.length > 0;

    const isTypeOfRenewableEnergyApplied =
      tempFilter?.typeOfRenewableEnergy?.length > 0;

    setIsFiltersApplied(
      isDateApplied ||
        isMonthApplied ||
        isImporterApplied ||
        isTypeOfRenewableEnergyApplied
    );

    setAppliedFilters((prevAppliedFilters) => ({
      ...prevAppliedFilters,
      Date: isDateApplied,
      "Month of energy export": isMonthApplied,
      Importer: isImporterApplied,
      "Type of renewable energy": isTypeOfRenewableEnergyApplied,
    }));
  };

  // Handle Sorting function
  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };

  const handleFilterDrawer = () => {
    setTempFilter({
      startDate: startDate,
      endDate: endDate,
      startMonth: startMonth,
      endMonth: endMonth,
      importer: selectedFields.importer,
      typeOfRenewableEnergy: selectedFields.typeOfRenewableEnergy,
    });
    setDrawerFilterOpen(false);
  };

  const columnHeadings = withFacilityHeading(
    [
      { title: "Date", fieldName: "createdAt" },
      { title: "Month of energy export", fieldName: "consumptionPeriod" },
      { title: "Importer", fieldName: "importer" },
      { fieldName: "typeOfRenewableEnergy", title: "Type of renewable energy" },
      { fieldName: "energyExported", title: "Energy exported (kWh)" },
    ],
    showFacilityColumn
  );

  const handleCloseBulkUpload = () => {
    setBulkUploadModal(false);
    fetchData();
  };

  // Function to render the selected filter component based on user's choice
  const renderSelectedFilter = () => {
    switch (selectedFilter) {
      case "Date":
        return (
          <DateRangePickerComponent
            startDate={tempFilter?.startDate}
            endDate={tempFilter?.endDate}
            setStartDate={(date) =>
              setTempFilter((prev) => ({ ...prev, startDate: date }))
            }
            setEndDate={(date) =>
              setTempFilter((prev) => ({ ...prev, endDate: date }))
            }
            setErrors={setErrors}
          />
        );
      case "Month of energy export":
        return (
          <MonthYearFilter
            startMonth={tempFilter?.startMonth}
            endMonth={tempFilter?.endMonth}
            setStartMonth={(month) =>
              setTempFilter((prev) => ({ ...prev, startMonth: month }))
            }
            setEndMonth={(month) => {
              setTempFilter((prev) => ({ ...prev, endMonth: month }));
            }}
            setErrors={setErrors}
            errors={errors.Month}
            title="Month of energy export"
          />
        );
      case "Importer":
        return (
          <MultiSelect
            title="Importer"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  importer: newValue.importer || newValue,
                };
              });
            }}
            setErrors={setErrors}
            field="importer"
            data={uniqueValues.importer || []}
          />
        );

      case "Type of renewable energy":
        return (
          <MultiSelect
            title="Type of renewable energy"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  typeOfRenewableEnergy:
                    newValue.typeOfRenewableEnergy || newValue,
                };
              });
            }}
            setErrors={setErrors}
            field="typeOfRenewableEnergy"
            data={uniqueValues.typeOfRenewableEnergy || []}
          />
        );
      default:
        return null;
    }
  };
  const uploadErrorClose = () => {
    setBulkUploadTable(true);
  };

  return (
    <MainDashboardLayout sidebar={<Scope4Layout />}>
      <Unauthorized requiredModule="Environment | Scope 4 | Carbon Avoidance | Renewable">
        <Box
          sx={{
            backgroundColor: "#ededed",
          }}
        >
          <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
          {/*Message popup for success or failure */}
          {/* View log, Edit, delete menus */}
          <Add
            id={element ? element._id : ""}
            addData={addData}
            setAddData={setAddData}
            data={element}
            title="Data"
            addUrl={`${api}/scope4/renewable-energy-export-avoidance/add`}
            updateUrl={`${api}/scope4/renewable-energy-export-avoidance/update`}
            fetchData={fetchData}
            setsnackOpen={setsnackOpen}
            inputData={inputData}
          />
          <View
            id={element ? element._id : ""}
            data={element}
            title={"Avoidance from Renewable Energy Export Details"}
            viewData={viewData}
            setViewData={setViewData}
            inputData={inputData}
            handleEdit={handleEdit}
          />
          <Cards
            data={bannerData}
            title={"Carbon Avoidance"}
            onFilterChange={handlePeriodChange}
            {...{
              setSelectedMonth,
              setSelectedYear,
              selectedMonth,
              selectedYear,
            }}
          />
          {deleteDialog && (
            <DeleteAlertDialog
              fetchData={updatePage}
              {...{
                deleteDialog,
                setDeleteDialog,
                id: element._id,
                url: `${api}/scope4/renewable-energy-export-avoidance/delte`,
                setsnackOpen,
                fetchData,
                fetchCardData,
              }}
            />
          )}
          {/* Filter Drawer */}
          {/* <Toolbar sx={{ padding: "0 16px", marginBottom: "20px" }}> */}
          {drawerFilterOpen && (
            <FilterDrawer
              {...{
                renderSelectedFilter,
                drawerFilterOpen,
                setDrawerFilterOpen,
                handleApplyFilters,
                handleFilterDrawer,
                setSelectedFilter,
                handleResetFilters,
                selectedFilter,
                filters,
                appliedFilters,
                selectedFields,
                setSelectedFields,
              }}
            />
          )}{" "}
          {/* Top Box for Heading, Filter Button, Add Data Button */}
          <TopMenuUpload
            setData={setElement}
            setAddData={setAddData}
            {...{
              // heading: "Coal",
              setBulkUploadModal,
              setDrawerFilterOpen,
              filterApplied: isFiltersApplied,
            }}
          />
          {/* </Toolbar> */}
          <TableContainer
            component={Paper}
            ref={tableContainerRef}
            sx={{ ...gridTablePaperSx, overflowX: "hidden" }}
          >
            <Box sx={{ width: "100%", minWidth: 0, overflow: "hidden" }}>
              <TableHeading
                heading={"Avoidance from Renewable Energy Export"}
              />
              <Box
                sx={{
                  ...getGridTableRowSx(columnWidth, showFacilityColumn),
                  borderBottom: "1px solid #ddd",
                  borderTop: "1px solid #ddd",
                }}
              >
                {columnHeadings.map((el) =>
                  isFacilityHeading(el) ? (
                    <FacilityColumnHeading
                      key={el.fieldName}
                      handleSort={handleSort}
                      sortConfig={sortConfig}
                    />
                  ) : (
                    <ColumnHeadings
                      key={el.fieldName}
                      {...{
                        title: el.title,
                        key: el.title,
                        handleSort,
                        field: el.fieldName,
                        sortConfig,
                      }}
                    />
                  )
                )}
                <Typography sx={gridTableActionHeaderSx}>
                  Action
                </Typography>
              </Box>
              {data.length === 0 ? (
                <NoDataFound />
              ) : (
                data.map((item) => (
                  <Box
                    key={item._id}
                    sx={{
                      ...getGridTableRowSx(columnWidth, showFacilityColumn),
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    {columnHeadings.map((el) =>
                      isFacilityHeading(el) ? (
                        <FacilityDataCell key={el.fieldName}>
                          {getFacilityName(item) || "N/A"}
                        </FacilityDataCell>
                      ) : (
                        <TableContent
                          key={el.fieldName}
                          {...{
                            fieldData:
                              el.fieldName === "consumptionPeriod"
                                ? getMonthName(item[el.fieldName]?.month) +
                                  " " +
                                  item[el.fieldName]?.year
                                : typeof item[el.fieldName] === "object" &&
                                  item[el.fieldName] !== null &&
                                  item[el.fieldName].name
                                ? item[el.fieldName].name
                                : item[el.fieldName] === 0
                                ? 0
                                : item[el.fieldName],
                            dateField:
                              el.fieldName === "createdAt"
                                ? item.createdAt
                                : false,
                          }}
                        />
                      )
                    )}
                    {/* Menu Action Icon */}
                    <MenuIcon {...{ handleMenuClick, field: item }} />
                  </Box>
                ))
              )}
            </Box>
          </TableContainer>
          {/* Pagination */}
          {totalPages > 1 && (
            <PaginationBox
              isShortContent={isShortContent}
              {...{ totalPages, page, handleChangePage }}
            />
          )}
          <MenuActions
            {...{
              id: element?._id,
              handleView,
              handleEdit,
              handleDelete,
              anchorEl,
              handleMenuClose,
            }}
          />
          {/*Add,Edit,Delete Icons & function calls */}
        </Box>

        {bulkUploadModal && (
          <BulkUploadModal
            onCloseBulkUpload={handleCloseBulkUpload}
            isBulkUploadModal={bulkUploadModal}
            setsnackOpen={setsnackOpen}
            excelData={excelData}
            setFormDataBulkUpload={setFormDataBulkUpload}
            formDataBulkUpload={formDataBulkUpload}
            setMatchData={setMatchData}
            errorClose={uploadErrorClose}
            matchedKey="statusList"
            // setBulkUploadTable={setBulkUploadTable}
            // setJsonBulkUpload={setJsonBulkUpload}
            setBulkUploadModal={setBulkUploadModal}
            fileName={"Renewable Energy Export Avoidance"}
            url={"/scope4/renewable-energy-export-avoidance/bulkupload"}
          />
        )}
        {console.log(bulkUploadTable, "bulkUploadTable")}
        {bulkUploadTable && (
          <FugitiveBulkUpload
            matchData={matchData}
            setMatchData={setMatchData}
            onClose={() => setBulkUploadTable(false)}
            bulkUploadTable={bulkUploadTable}
            setFormData={setFormDataBulkUpload}
            formData={formDataBulkUpload}
            jsonBulkUpload={formDataBulkUpload}
            {...{ formDataBulkUpload, setFormDataBulkUpload }}
            title1="Type of renewable energy"
            keyValue1="typeOfRenewableEnergy"
            matched1="matchedtypeOfRenewableEnergy"
            options1={["Solar", "Wind", "Biogas"]}
            bulkUploadUrl={`/scope4/renewable-energy-export-avoidance/jsonUpload`}
            onConfirm={onConfirm}
            setsnackOpen={setsnackOpen}
          />
        )}
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default RenewableEnergyExport;
